import { injectable } from 'inversify'
import { Module, VuexModule, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { lazyInject } from '@/app/container';
import { QuizStoreModule, QuizStoreModuleSymbol  } from '@/app/quiz'
import { ok, err, Result } from '@xlearn/common'
import { QuizRole, ExamDetails }  from '@/app/quiz'
export { QuizRole, GradingMethod }  from '@/app/quiz'

export const ExamStoreModuleSymbol = Symbol.for('ExamStoreModule');

export type FindExamError = 'exams-not-loaded' | 'exam-not-found'

type Exam = {
  id: string
  title: string
  href: string
  parentTitle: string
  role: QuizRole
} & ExamDetails

@injectable()
@Module({
  namespaced: true,
  name: 'exam',
  store,
  dynamic: true
})
export class ExamStoreModule extends VuexModule {

  @lazyInject(QuizStoreModuleSymbol)
  private quizStoreModule: QuizStoreModule
    
  get findExam() {

    const self = this
    return function (id: string): Result<Exam, FindExamError> {
      
      if (self.loadingPhase !== 'loaded') {
        return err('exams-not-loaded' as FindExamError)
      }

      const found = self.exams.find(x => x.id === id)
      if (!found) {
        return err('not-found' as FindExamError)
      }

      return ok(found)
    }
  }

  get exams(): Exam[] {

    return this.quizStoreModule.quizzes.filter(x => x.hasExam).map(quiz => {

      if (!quiz.hasExam) { throw new Error('Coding error' )}

      return {
        id: quiz.id,
        title: quiz.title,
        href: quiz.href,
        parentTitle: quiz.context.parentTitle,
        role: quiz.role,
        ...quiz.exam
      }
    })
  }

  get loadingPhase() {
    return this.quizStoreModule.loadingPhase
  }
}

export default getModule(ExamStoreModule);

